import React, { useContext } from 'react';

import { useTranslation } from 'next-i18next';
import Image from 'next/image';

import { MobileSizeContext } from '../../../helpers/MobileSizeContext';
import Strip from '../../common/Strip';
import Styles from './QuoteBanner.module.scss';

const QuoteBanner = () => {
  const { t } = useTranslation('clients');
  const { isTablet } = useContext(MobileSizeContext);
  const {
    quoteBanner: { notABank, weAre },
  } = t('corporate-treasurers', {
    returnObjects: true,
  }) as any;

  return (
    <Strip
      variant="blue"
      style={{
        paddingTop: 50,
        paddingBottom: 50,
        zIndex: 1,
        position: 'relative',
      }}
    >
      <div className={Styles.wrapper}>
        <Image
          width={74}
          height={63}
          className={Styles.quoteUp}
          src="/images/client/quoteUp.png"
          alt='"'
        />
        {notABank.map((text: any, i: number, list: string | any[]) => (
          <p
            key={text}
            className={Styles.item}
            style={i === list.length - 1 ? { marginBottom: 16 } : undefined}
          >
            {text}
          </p>
        ))}
        <p className={Styles.item}>
          {weAre[0]}
          <span>{weAre[1]}</span>
        </p>
        <p className={Styles.item}>
          <span>{weAre[2]}</span>
        </p>
        <Image
          className={Styles.quoteDown}
          width={74}
          height={63}
          src="/images/client/quoteDown.png"
          alt='"'
        />
      </div>
    </Strip>
  );
};

export default QuoteBanner;
